/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PencilSparkleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABcUlEQVR4nN1Tu07DQBDMB1BTAuI3kCgowbe7NnF2E6UnSCFQ0ZLv4BtCDU3atEkfIURBKpQyrdHmIR/O+RWHhpNWluy9md2Zca32744JGmdAPNdnbi/KHSC/G+K3y6B1XIgAiAdAEukzG5z7q75VGZIPRD7Jm3wNvikeuDYBaJz/7itAorK4LgHxPNnr++1DBUsjccpVZAOD8gjIQ51SK40EkF9TpQKUF5cHxtJ8I0UGybRUikzC0DwSQ9xNJdgixG1wqz6vgtap54VHGtf1u6d9gUf2Jmq8pmuv4BCbOiwMXBqcJNJ0/Rk4lNNcHspNzv3C4GEYHhiUxa7gAFI3yDMPm9fu6X25qDK5IR6v/4GxkwB86VUAv030dRz68/MusgDKxB1dmYDPYdyMPCo9OfIs5853TEAyTcn4AojvXbKqoZkbgNQtHaW9JEEeLeXypafGa7qcptlSkXRscMTmTd6d0ic3RVWPymWIvwxxYH/4AZ/4BPcQr4pnAAAAAElFTkSuQmCC)
 */
export const PencilSparkleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6.3 2.55a.85.85 0 0 0-1.6 0l-.35.97a1.4 1.4 0 0 1-.83.83l-.97.35a.85.85 0 0 0 0 1.6l.97.35c.38.15.68.45.83.83l.35.97a.85.85 0 0 0 1.6 0l.35-.97c.15-.38.45-.68.83-.83l.97-.35a.85.85 0 0 0 0-1.6l-.97-.35a1.4 1.4 0 0 1-.83-.83l-.35-.97ZM13.96 5.46l4.58 4.58a1 1 0 0 0 1.42 0l1.38-1.38a2 2 0 0 0 0-2.82l-3.18-3.18a2 2 0 0 0-2.82 0l-1.38 1.38a1 1 0 0 0 0 1.42ZM2.11 20.16l.73-4.22a3 3 0 0 1 .83-1.61l7.87-7.87a1 1 0 0 1 1.42 0l4.58 4.58a1 1 0 0 1 0 1.42l-7.87 7.87a3 3 0 0 1-1.6.83l-4.23.73a1.5 1.5 0 0 1-1.73-1.73ZM18.48 15.71a1.1 1.1 0 0 1 2.04 0l.46 1.24c.19.5.57.88 1.07 1.07l1.24.46c.95.35.95 1.7 0 2.04l-1.24.46c-.5.19-.88.57-1.07 1.07l-.46 1.24a1.1 1.1 0 0 1-2.04 0l-.46-1.24a1.8 1.8 0 0 0-1.07-1.07l-1.24-.46a1.1 1.1 0 0 1 0-2.04l1.24-.46c.5-.19.88-.57 1.07-1.07l.46-1.24Z"
        className={colorClass}
      />
    </svg>
  );
};
